export enum RECONCILIATION_ADJUSTMENT_PERMISSIONS {
  RECONCILIATION_ADJUSTMENT_VIEW = 'CONCILIATION_RECONCILIATIONADJUSTMENTVIEW',
  RECONCILIATION_ADJUSTMENT_WRITE = 'CONCILIATION_RECONCILIATIONADJUSTMENTWRITE',
}
